export default "__VITE_ASSET__CSNP2PFa__"